import { v4 as uuidv4 } from "uuid";
import { FieldProps, GroupProps } from "../../utils/functionsInterfaces";
import { displayError, displayInfo } from "../../utils/messageToast";

export const handleCopyGroup = (
  groupId: string,
  groupName: string,
  form: GroupProps[],
  setForm: React.Dispatch<React.SetStateAction<GroupProps[]>>,
  uuid: string,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>,
  copies = 1
) => {
  try {
    const totalCopies = Math.min(Math.max(Math.floor(copies || 1), 1), 200);

    // Função recursiva para encontrar o grupo a ser copiado e o grupo pai
    const findGroupAndParent = (
      groups: (GroupProps | FieldProps)[],
      groupId: string,
      uuid: string
    ): { group: GroupProps | null; parent: GroupProps | null } => {
      for (const group of groups) {
        if ("children" in group) {
          if (group.uuid === uuid || group.id === groupId) {
            return { group: group as GroupProps, parent: null };
          }
          const found = findGroupAndParent(group.children ?? [], groupId, uuid);
          if (found.group) {
            if (found.parent === null) {
              found.parent = group as GroupProps;
            }
            return found;
          }
        }
      }
      return { group: null, parent: null };
    };

    const cloneChild = (child: FieldProps | GroupProps): FieldProps | GroupProps => {
      const next = { ...child, uuid: uuidv4(), isNew: true };
      if ("children" in child && child.children) {
        next.children = child.children.map(cloneChild) as any;
      }
      return next as FieldProps | GroupProps;
    };

    const newForm = [...form];
    const nameWithoutNumber = groupId.replace(/\d+$/, "");
    const groupNameWithoutNumber = groupName.replace(/\s+\d+$/, "").trim();

    for (let i = 0; i < totalCopies; i++) {
      const { group: groupToCopy, parent: parentGroup } = findGroupAndParent(
        newForm,
        groupId,
        uuid
      );
      if (!groupToCopy) {
        console.error("Group not found");
        return;
      }

      const targetGroup = parentGroup ? parentGroup.children : newForm;

      const sameNameGroups = targetGroup.filter((group: any) => {
        const otherNameWithoutNumber = group.id.replace(/\d+$/, "");
        return otherNameWithoutNumber === nameWithoutNumber;
      });

      let incrementedCounter = sameNameGroups.length;
      let newGroupId = `${nameWithoutNumber}${incrementedCounter}`;
      let newGroupName = `${groupNameWithoutNumber} ${incrementedCounter}`;

      while (targetGroup.some((group: any) => group.id === newGroupId)) {
        incrementedCounter++;
        newGroupId = `${nameWithoutNumber}${incrementedCounter}`;
        newGroupName = `${groupNameWithoutNumber} ${incrementedCounter}`;
      }

      const copiedGroup: GroupProps = {
        ...groupToCopy,
        uuid: uuidv4(),
        id: newGroupId,
        name: newGroupName,
        isNew: true,
        children: groupToCopy.children.map(cloneChild) as any,
      };

      const groupWithMaxNumberIndex = targetGroup.reduce(
        (acc: number, group: GroupProps, index: number) => {
          if (group.id.includes(nameWithoutNumber)) {
            acc = index;
          }
          return acc;
        },
        0
      );

      targetGroup.splice(groupWithMaxNumberIndex + 1, 0, copiedGroup);
    }

    setForm(newForm);
    setButtonSave(true);
    displayInfo(`Grupo duplicado! (${totalCopies}x)`);
  } catch (error: any) {
    displayError("Erro ao duplicar grupo!");
  }
};
